import script from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DateRangePicker.vue?vue&type=style&index=0&id=65685c2f&lang=css"

const __exports__ = script;

export default __exports__